import { Box, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PatientDetailEditForm from "../../PatientDetailEditForm";

export default function EditPatientDetailModal({ close }) {
  return (
    <Box
      sx={{
        width: '570px',
        borderRadius: '16px',
        backgroundColor: 'background.white',
        overflowY: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '24px 16px 8px',
          borderBottom: '1px solid',
          borderColor: 'primary.mediumGray',
        }}
      >
        <Typography variant="h1">
          Edit patient details
        </Typography>
        <CloseIcon
          sx={{
            width: '32px',
            height: '32px',
            color: 'primary.black',
            cursor: 'pointer'
          }}
          onClick={close}
        />
      </Box>
      <PatientDetailEditForm onClose={close} />
    </Box>
  )
}